import { render, staticRenderFns } from "./CardDownloadEnvios.vue?vue&type=template&id=30dfee46"
import script from "./CardDownloadEnvios.vue?vue&type=script&lang=js"
export * from "./CardDownloadEnvios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports